'use client';

import { ContentfulModule, Color, ContentfulCollection } from 'libs/contentful/types';

import { Margins } from 'types/constants';
import { CardImageItem } from '../BaseCard/types';
import BaseCardCarousel from '../BaseCard/BaseCardCarousel';
import { liveUpdateAttrs } from 'libs/contentful/utils';

export interface CardsImageCarouselProps extends Omit<ContentfulModule, 'name'> {
  color: Color;
  cardStyle: string;
  cardImageItems: ContentfulCollection<CardImageItem>;
  margins: Margins;
  sectionName?: string;
  testId?: string;
}

const CardsImageCarousel = ({
  sys,
  color,
  cardStyle,
  cardImageItems,
  margins,
  sectionName,
  testId,
}: CardsImageCarouselProps) => {
  const testFixture = testId ?? 'cards-image-carousel';
  return (
    <section
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className="w-full"
      data-testid={`${testFixture}-section`}
      {...liveUpdateAttrs(sys?.id, 'content')}>
      <BaseCardCarousel
        cardItems={cardImageItems}
        color={color}
        margins={margins}
        cardStyle={cardStyle}
        testId={testFixture}
        sectionName={sectionName}
        sys={sys}
      />
    </section>
  );
};

export default CardsImageCarousel;
